import type { CategoryInsights } from "@/api/categoryService";
import type { CategoryData } from "@/pages/category/@slug/+data";
import { Link } from "@/components/Link";
import { ledeSentence, lowRatingBar } from "@/lib/categoryLede";

// The category page header: breadcrumb, H1, description, then the category's numbers as ONE
// sentence and a bar for the share of 1-2 star experiences. Every number comes from the insights
// payload (feed-eligible reviews on published stores); nothing here is an editorial judgement, and
// the methodology line says where the numbers come from. With no insights (fetch failed) the header
// renders title + description only, exactly as before the blocks existed. Copy rules (count
// agreement, minimum samples for the average and the bar) live in lib/categoryLede.ts.
export default function CategoryHeader({
  category,
  insights,
}: {
  category: CategoryData;
  insights: CategoryInsights | null;
}) {
  const bar = insights ? lowRatingBar(insights) : null;

  return (
    <header className="catpage-head">
      <nav className="catpage-crumbs" aria-label="مسار الصفحة">
        <Link to="/">الرئيسية</Link>
        <span aria-hidden="true">/</span>
        <Link to="/categories">الفئات</Link>
        <span aria-hidden="true">/</span>
        <span aria-current="page">{category.title.ar}</span>
      </nav>

      <h1>{category.title.ar}</h1>
      {category.description && <p className="catpage-desc">{category.description}</p>}

      {insights && (
        <>
          <p className="catpage-lede">{ledeSentence(insights)}</p>
          {bar && (
            <div className="catpage-bar" role="img" aria-label={bar.label}>
              <div className="catpage-bar-track" aria-hidden="true">
                <div className="catpage-bar-fill" style={{ width: `${bar.percent}%` }} />
              </div>
              <span className="catpage-bar-label" aria-hidden="true">
                {bar.label}
              </span>
            </div>
          )}
          <p className="catpage-method">
            الأرقام محسوبة من التقييمات المنشورة على يتفرج (تقييمات الأعضاء وتجارب جروبات فيسبوك)
            وتتحدث كل ساعة.
          </p>
        </>
      )}
    </header>
  );
}
